import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import Button from 'components/CustomButtons/Button.js';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem';

import { wsFindBy } from 'services/WService';

const useStyles = makeStyles((theme) => ({
  ...styles,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
}));

export default function FilterArticle(props) {
  const promo = props.promo;
  const classes = useStyles();
  const { providers, categories, families } = props;

  //estados para filtros y deshabilitarlos
  const [providerId, setProviderId] = useState(promo.base_business_partner_id);
  const [categoryId, setCategoryId] = useState(0);
  const [familyId, setFamilyId] = useState(0);
  const [itemName, setItemName] = useState(0);
  const [itemCode, setItemCode] = useState(0);

  /* console.log(promo, providerId  providers, categories, families); */
  async function listProduct(
    providerId = 0,
    categoryId = 0,
    familyId = 0,
    itemName = 0,
    itemCode = 0
  ) {
    let search = {
      base_business_partner_id: providerId
    };

    if (itemName != 0) {
      search.ItemName = itemName;
    } else if (itemCode != 0) {
      search.ItemCode = itemCode;
    } else if (familyId != 0) {
      search.logi_family_id = familyId;
    } else if (categoryId != 0) {
      search.logi_category_id = categoryId;
    }

    let response = await wsFindBy('prom/promotion/group-stock/product', { ...search, state: 'A' });
    if (response.success) {
      props.setProducts(response.data.products);
      if(props.setWarehouses !== undefined){
        props.setWarehouses(response.data.warehouses);
      }
    }
  }

  useEffect(() => {
    setProviderId(promo.base_business_partner_id);
  }, [promo]);

  useEffect(() => {
    listProduct(providerId, categoryId, familyId);
  }, [providerId, categoryId, familyId]);

  return (
    <GridContainer>
      <GridItem xs={2}>
        <FormControl fullWidth margin="normal" size="small" key={providerId}>
          <InputLabel>Proveedor</InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            value={providerId || 0}
            onChange={(e) => {
              setProviderId(e.target.value);
              props.listCategories(e.target.value);
              if (e.target.value == 0) {
                setCategoryId(0);
                props.setCategories([]);
                setFamilyId(0);
                props.setFamilies([]);
              }
            }}
          >
            {providers.map((provider, i) => {
              return (
                <MenuItem value={provider.id} key={i}>
                  {provider.CardName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={2}>
        <FormControl fullWidth margin="normal" size="small" key={providerId}>
          <InputLabel>Categoría</InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            value={categoryId}
            disabled={providerId == 0}
            onChange={(e) => {
              setCategoryId(e.target.value);
              props.listFamilies(e.target.value);
              if (e.target.value == 0) {
                setFamilyId(0);
                props.setFamilies([]);
              }
            }}
          >
            <MenuItem value={0}>Ninguno</MenuItem>
            {categories.map((category, i) => {
              return (
                <MenuItem value={category.id} key={i}>
                  {category.description}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Familia</InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            value={familyId}
            disabled={categoryId == 0}
            onChange={(e) => {
              setFamilyId(e.target.value);
            }}
          >
            <MenuItem value={0}>Ninguno</MenuItem>
            {families.map((family, i) => {
              return (
                <MenuItem value={family.id} key={i}>
                  {family.description}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={2}>
        <TextField
          label="Nombre producto"
          fullWidth
          type="text"
          name="ItemName"
          margin="normal"
          onChange={(e) => {
            setItemName(e.target.value);
          }}
        />
      </GridItem>
      <GridItem xs={2}>
        <TextField
          label="Código producto"
          fullWidth
          type="text"
          name="ItemCode"
          margin="normal"
          onChange={(e) => {
            setItemCode(e.target.value);
          }}
        />
      </GridItem>
      <GridItem xs={2}>
        <Button
          onClick={() => {
            listProduct(providerId, categoryId, familyId, itemName, itemCode);
          }}
        >
          Buscar
        </Button>
      </GridItem>
    </GridContainer>
  );
}
